module.exports = __webpack_public_path__ + "assets/img/nodata.8ce95b25.png";